export const topBarHeight = '81px'

export const themeColors = {
  primary: '#005141',
  accent: '#FF6700',
  red: '#F44336',
  green: '#005141',
  greenBright: '#A7FF00',
  greenLight: '#008E69',
  blue: '#448AFF',
} as const
